import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import SimpleBar from "simplebar-react";
import { Link, useLocation } from "react-router-dom";
import MetisMenu from "metismenujs";
import withRouter from "../Common/withRouter";
import { withTranslation } from "react-i18next";
import { toggle } from "../../store/slices/authSlice";
import home from "../../assets/images/home.svg";
import rated from "../../assets/images/Rated.svg";
import gym from "../../assets/images/gym.svg";
import gym1 from "../../assets/images/gym1.svg";
import users from "../../assets/images/users.svg";
import staff from "../../assets/images/staff.svg";
import payments from "../../assets/images/payments.svg";
import setting from "../../assets/images/settings.svg";
import bank from "../../assets/images/bank.svg";
import down from "../../assets/images/down.svg";
import up from "../../assets/images/up.svg";
import logout from "../../assets/images/Logout.svg";
import bill from "../../assets/images/bill.svg";
import owner from "../../assets/images/Organizer.svg";
import { useNavigate } from "react-router-dom";
import pass2 from "../../assets/images/pass2.svg";
import { useDispatch, useSelector } from "react-redux";
import { Alert } from "reactstrap";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
const SidebarContent = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const toggleModal = () => setModalOpen(!modalOpen);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState("");
  const [icon, setIcon] = useState(false);
  const path = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  function tToggle() {
    var body = document.body;
    var windowSize = document.documentElement.clientWidth;
    if (windowSize <= 991) {
      body.classList.toggle("vertical-collpsed");
      body.classList.toggle("sidebar-enable");
    }
  }
  const handlelogout = () => {
    navigate("/logout");
  };
  useEffect(() => {
    new MetisMenu("#side-menu");
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    const currentPath = path.pathname;
    setSelectedItem(currentPath);
  }, [path]);
  const { appRole, userPermissions } = useSelector((state) => {
    return state.auth.currentUser;
  });

  const menuItems =
    appRole == "admin" || appRole == "staff"
      ? [
          {
            title: "Dashboard",
            path: "/dashboard",
            icon: home,
          },

          (userPermissions?.gym?.["Create Gym"] ||
            userPermissions?.gym?.["View Gym"]) && {
            title: "Gyms",
            path: "/#",
            icon: gym1,
            subMenu: [
              userPermissions?.gym?.["Create Gym"] && {
                title: "Add Gyms",
                path: "/add-gyms",
                icon: gym1,
              },
              userPermissions?.gym?.["Create Gym"] && {
                title: "Gym Categories",
                path: "/gym-category",
                icon: gym,
              },
              userPermissions?.gym?.["Create Gym"] && {
                title: "Add in Bulk",
                path: "/add-bulk",
                icon: gym1,
              },

              userPermissions?.gym?.["View Gym"] && {
                title: "Gyms Listing",
                path: "/list-gyms",
                icon: gym1,
              },
              userPermissions?.gym?.["View Gym"] && {
                title: "Gym Ratings",
                path: "/gym-ratings",
                icon: rated,
              },
            ],
          },

          (userPermissions?.user?.["Active User"] ||
            userPermissions?.user?.["Block User"] ||
            userPermissions?.user?.["Archive User"]) && {
            title: "Users",
            path: "/dashboard/users",
            icon: users,
            subMenu: [
              userPermissions?.user?.["Active User"] && {
                title: "Active Users",
                path: "/list-users",
                icon: users,
              },
              userPermissions?.user?.["Block User"] && {
                title: "Archive Users",
                path: "/archive-users",
                icon: users,
              },
              userPermissions?.user?.["Archive User"] && {
                title: "Blocked Users",
                path: "/blocked-users",
                icon: users,
              },
            ],
          },
          (userPermissions?.equipment?.["View Equipment"] ||
            userPermissions?.equipment?.["Create Equipment"]) && {
            title: "Equipments",
            path: "/dashboard/Pass",
            icon: gym,
            subMenu: [
              userPermissions?.equipment?.["Create Equipment"] && {
                title: "Add Equipments",
                path: "/add-equip?admin=true",
                icon: gym,
              },

              userPermissions?.equipment?.["View Equipment"] && {
                title: "Equipment Listing",
                path: "/equip-listing?admin=true&type=default",
                icon: gym,
              },    userPermissions?.equipment?.["View Equipment"] && {
                title: "Add Brand",
                path: "/add-equipment-brand",
                icon: gym,
              },
               userPermissions?.equipment?.["View Equipment"] && {
                title: "Brand Listing",
                path: "/view-equipment-brand",
                icon: gym,
              },
            ],
          },
          (userPermissions?.staff?.["View Staff"] ||
            userPermissions?.staff?.["Create Staff"]) && {
            title: "Staff",
            path: "/dashboard/staff",
            icon: staff,
            subMenu: [
              userPermissions?.staff?.["Create Staff"] && {
                title: "Add Staff",
                path: "/add-staff",
                icon: staff,
              },
              userPermissions?.staff?.["View Staff"] && {
                title: "Staff Listing",
                path: "/list-staff",
                icon: staff,
              },
            ],
          },
          (userPermissions?.staff?.["View Staff"] ||
            userPermissions?.staff?.["Create Staff"]) && {
            title: "Gym Owner",
            path: "/dashboard/gymowner",
            icon: owner,
            subMenu: [
              userPermissions?.staff?.["Create Staff"] && {
                title: "Add Gym Owner",
                path: "/add-gymowner",
                icon: owner,
              },
              userPermissions?.staff?.["View Staff"] && {
                title: "Gym Owner Listing",
                path: "/list-gymowner",
                icon: owner,
              },
            ],
          },
          // {
          //   title: "Payments",
          //   path: "/dashboard/payments",
          //   icon: payments,
          //   subMenu: [
          //     {
          //       title: "Add Payments ",
          //       path: "/add-payments",
          //       icon: payments,
          //     },
          //     {
          //       title: "Payment Listing",
          //       path: "/gym-payments",
          //       icon: payments,
          //     },
          //   ],
          // },
          (userPermissions?.blog?.["View Blog"] ||
            userPermissions?.blog?.["Create Blog"]) && {
            title: "Blogs/News",
            path: "/dashboard/blogs",
            icon: payments,
            subMenu: [
              userPermissions?.blog?.["Create Blog"] && {
                title: "Add Blog",
                path: "/add-blog",
                icon: payments,
              },
              userPermissions?.blog?.["View Blog"] && {
                title: "Blog List",
                path: "/list-blog",
                icon: payments,
              },
            ],
          },

          (appRole == "admin" ||
            userPermissions?.billing?.["Gym Transaction"] ||
            userPermissions?.billing?.["Gym Revenue"] ||
            userPermissions?.billing?.["Payment Payout"]) && {
            title: "Gym Billing",
            path: "/dashboard/billing",
            icon: bill,
            subMenu: [
              (appRole == "admin" ||
                userPermissions?.billing?.["Gym Revenue"]) && {
                title: "Gym Revenue",
                path: "/gym-payout",
                icon: bill,
              },
              (appRole == "admin" ||
                userPermissions?.billing?.["Gym Transaction"]) && {
                title: "Gym Transaction",
                path: "/transaction",
                icon: bill,
              },
              (appRole == "admin" ||
                userPermissions?.billing?.["Payment Payout"]) && {
                title: "Payment Payout",
                path: "/clearance",
                icon: bill,
              },
            ],
          },
          {
            title: "Settings",
            path: "/profile-setting",
            icon: setting,
          },

          {
            title: "Logout",
            path: "/logout",
            icon: logout,
          },
        ]
      : [
          {
            title: "Gym Dashboard",
            path: "/gymDashboard",
            icon: home,
          },
          (userPermissions?.gym?.["Create Gym"] ||
            userPermissions?.gym?.["View Gym"]) && {
            title: "Gyms",
            path: "/#",
            icon: gym1,
            subMenu: [
              userPermissions?.gym?.["View Gym"] && {
                title: "Gyms Listing",
                path: "/list-gyms",
                icon: gym1,
              },
              userPermissions?.gym?.["View Gym"] && {
                title: "Gym Ratings",
                path: "/gym-owner-ratings",
                icon: rated,
              },
            ],
          },
          (userPermissions?.equipment?.["View Equipment"] ||
            userPermissions?.equipment?.["Create Equipment"]) && {
            title: "Equipments",
            path: "/dashboard/equipments",
            icon: gym,
            subMenu: [
              userPermissions?.equipment?.["Create Equipment"] && {
                title: "Add Equipments",
                path: "/add-equip",
                icon: gym,
              },

              userPermissions?.equipment?.["View Equipment"] && {
                title: "Equipment Listing",
                path: "/equip-listing",
                icon: gym,
              },
                  userPermissions?.equipment?.["View Equipment"] && {
                title: "Add Brand",
                path: "/add-equipment-brand",
                icon: gym,
              },
               userPermissions?.equipment?.["View Equipment"] && {
                title: "Brand Listing",
                path: "/view-equipment-brand",
                icon: gym,
              },
            ],
          },
          (userPermissions?.passes?.["View Pass"] ||
            userPermissions?.passes?.["Create Pass"]) && {
            title: "Pass",
            path: "/dashboard/Pass",
            icon: pass2,
            subMenu: [
              userPermissions?.passes?.["Create Pass"] && {
                title: "Add Passes",
                path: "/add-passes",
                icon: pass2,
              },
              userPermissions?.passes?.["View Pass"] && {
                title: "Redeem Passes",
                path: "/redeem-passes",
                icon: pass2,
              },
              userPermissions?.passes?.["View Pass"] && {
                title: "Pass Listing",
                path: "/list-passes",
                icon: pass2,
              },
            ],
          },
          (userPermissions?.passes?.["View Pass"] ||
            userPermissions?.passes?.["Create Pass"]) && {
            title: "Bank",
            path: "/dashboard",
            icon: bank,
            subMenu: [
              userPermissions?.passes?.["View Pass"] && {
                title: "Bank Listing",
                path: "/list-bank",
                icon: bank,
              },
            ],
          },
          (userPermissions?.staff?.["View Staff"] ||
            userPermissions?.staff?.["Create Staff"]) && {
            title: "Staff",
            path: "/dashboard/staff",
            icon: staff,
            subMenu: [
              userPermissions?.staff?.["Create Staff"] && {
                title: "Add Staff",
                path: "/add-staff",
                icon: staff,
              },
              userPermissions?.staff?.["View Staff"] && {
                title: "Staff Listing",
                path: "/list-staff",
                icon: staff,
              },
            ],
          },
          (userPermissions?.blog?.["View Blog"] ||
            userPermissions?.blog?.["Create Blog"]) && {
            title: "Blogs/News",
            path: "/dashboard/blogs",
            icon: payments,
            subMenu: [
              userPermissions?.blog?.["Create Blog"] && {
                title: "Add Blog",
                path: "/add-blog",
                icon: payments,
              },
              userPermissions?.blog?.["View Blog"] && {
                title: "Blog List",
                path: "/list-blog",
                icon: payments,
              },
            ],
          },

          (userPermissions?.billing?.["Gym Transaction"] ||
            userPermissions?.billing?.["Gym Revenue"] ||
            userPermissions?.billing?.["Payment Payout"]) && {
            title: "Gym Billing",
            path: "/dashboard/billing",
            icon: bill,
            subMenu: [
              userPermissions?.billing?.["Gym Revenue"] && {
                title: "Gym Revenue",
                path: "/gym-payout",
                icon: bill,
              },
              userPermissions?.billing?.["Gym Transaction"] && {
                title: "Gym Transaction",
                path: "/transaction",
                icon: bill,
              },
              userPermissions?.billing?.["Payment Payout"] && {
                title: "Payment Payout",
                path: "/clearance",
                icon: bill,
              },
            ],
          },

          {
            title: "Logout",
            path: "/logout",
            icon: logout,
          },
        ];

  return (
    <React.Fragment>
      <div
        id="sidebar-menu"
        className="d-flex flex-column h-100 justify-content-between"
      >
        <div className="">
          <div className="ff-sora font-size-14 fw-normal light-black mx-3">
            {props.t("Menu Options")}
          </div>
          <ul
            className="metismenu list-unstyled d-flex flex-column h-100 justify-content-start"
            id="side-menu"
          >
            {menuItems.map(
              (el, index) =>
                el != undefined && (
                  <li key={index} className="my-1">
                    <Link
                      to={el?.path}
                      className={`waves-effect ${
                        selectedItem === el?.path ? "selected-link" : ""
                      } ${el?.subMenu ? "has-arro" : ""}`}
                      onClick={(e) => {
                        setSelectedItem(el?.path);
                        setIcon((prevState) => !prevState);
                        if (el?.path === "/logout") {
                          e.preventDefault();
                          setModalOpen(true);
                          dispatch(toggle());
                        } else if (
                          el?.path === "/profile-setting" ||
                          el?.title === "Dashboard" ||
                          el?.path === "/gymDashboard"
                        ) {
                          tToggle();
                          dispatch(toggle());
                        }
                      }}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src={el?.icon}
                          alt={el?.title}
                          className="icon-image"
                          style={{ width: "20px", marginRight: "10px" }}
                        />
                        <span className="ff-sora font-size-16 secondary-black fw-normal">
                          {el?.title}
                        </span>
                      </div>
                      {el?.subMenu && (
                        <img
                          className="float-end"
                          src={selectedItem === el?.path && icon ? up : down}
                          alt="Down arrow"
                        />
                      )}
                    </Link>

                    {el?.subMenu && (
                      <ul className="sub-menu">
                        {el.subMenu.map(
                          (subEl, subIndex) =>
                            subEl != undefined && (
                              <li key={subIndex} className="my-0">
                                <Link
                                  to={subEl?.path}
                                  className={`waves-effect ${
                                    selectedItem === subEl.path
                                      ? "selected-link"
                                      : ""
                                  }`}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                  onClick={() => (
                                    dispatch(toggle()),
                                    setSelectedItem(subEl.path),
                                    tToggle()
                                  )}
                                >
                                  <span className="ff-sora font-size-14 secondary-black fw-normal">
                                    {subEl?.title}
                                  </span>
                                </Link>
                              </li>
                            )
                        )}
                      </ul>
                    )}
                  </li>
                )
            )}
          </ul>
        </div>

        {(appRole == "admin" || appRole == "staff") && (
          <div>
            {userPermissions?.other?.["Term"] && (
              <Link
                to={"/add-termscondition"}
                onClick={() => (tToggle(), dispatch(toggle()))}
              >
                <div className="ps-4 ms-1  ff-sora font-size-14 light-black">
                  Terms & Condition
                </div>
              </Link>
            )}
            {userPermissions?.other?.["Privacy Policy"] && (
              <Link
                to={"/add-privacypolicy"}
                onClick={() => (tToggle(), dispatch(toggle()))}
              >
                <div className="ps-4 ms-1  ff-sora font-size-14 light-black">
                  Privacy Policy
                </div>
              </Link>
            )}
            {userPermissions?.other?.["Privacy Policy"] && (
              <Link
                to={"/list-faq"}
                onClick={() => (tToggle(), dispatch(toggle()))}
              >
                <div className="ps-4 ms-1  ff-sora font-size-14 light-black">
                  FAQ
                </div>
              </Link>
            )}
            {userPermissions?.other?.["Request A Feature"] && (
              <Link
                to={"/list-requestfeature"}
                onClick={() => (tToggle(), dispatch(toggle()))}
              >
                <div className="ps-4 ms-1  ff-sora font-size-14 light-black">
                  Request A Feature
                </div>
              </Link>
            )}
            {userPermissions?.other?.["Contact Us"] && (
              <Link
                to={"/list-contactus"}
                onClick={() => (tToggle(), dispatch(toggle()))}
              >
                <div className="ps-4 ms-1  ff-sora font-size-14 light-black">
                  Contact Us
                </div>
              </Link>
            )}
          </div>
        )}
      </div>
      <Modal
        isOpen={modalOpen}
        toggle={toggleModal}
        className="modal-dialog-centered rounded-4"
      >
        <ModalHeader
          toggle={toggleModal}
          className="font-size-16 fw-medium ff-sora"
        >
          Confirm logout
        </ModalHeader>
        <ModalBody className="font-size-14 fw-normal ff-sora">
          Are you sure you want to log out?
        </ModalBody>
        <ModalFooter>
          <Button
            type="submit"
            className=" rounded-pill"
            onClick={handlelogout}
          >
            Yes
          </Button>
          <Button color="white" className="rounded-pill1" onClick={toggleModal}>
            No
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));
